import { SET_MY_USER, REQUEST_MY_USER } from "../constants/actionTypes";
import { USER } from "../constants/initialStates";

const user = (state = USER, action) => {
  switch (action.type) {
    case REQUEST_MY_USER:
      return {
        ...state,
        isLoaded: false,
        isFetching: true
      };
    case SET_MY_USER:
      return {
        ...state,
        item: {
          id: action.user.item.id,
          username: action.user.item.username,
          f: action.user.item.f,
          i: action.user.item.i,
          o: action.user.item.o,
          email: action.user.item.email
        },
        isLoaded: true,
        isFetching: false
      };
    default:
      return state;
  }
};

// GET INFO
export default user;
